export default __webpack_public_path__ + "static/media/190629_190332_IMG_2601.6a4e9de9.jpg";